// extracted by mini-css-extract-plugin
export var authorText = "authorCard-module--authorText--1uoL9";
export var authorContent = "authorCard-module--authorContent--1nzP6";
export var authorDetails = "authorCard-module--authorDetails--1_Y7U";